import { Box, styled } from '@mui/material';

/** Hide scrollbar while keeping scroll behavior (touch / trackpad). */
export const hideScrollbarSx = {
  scrollbarWidth: 'none',
  msOverflowStyle: 'none',
  '&::-webkit-scrollbar': { display: 'none' },
} as const;

/** Full-height page shell: fills dashboard outlet; desktop uses natural height so main scrolls once. */
export const PageRoot = styled(Box)(({ theme }) => ({
  display: 'flex',
  width: '100%',
  flex: 1,
  minHeight: '100%',
  [theme.breakpoints.down('md')]: {
    minHeight: '100vh',
  },
  [theme.breakpoints.up('md')]: {
    height: 'auto',
    minHeight: '100%',
    flex: '1 1 auto',
  },
}));

/** Scrollable area inside PageRoot (mobile); desktop scroll is on dashboard main. */
export const PageScrollArea = styled(Box)(({ theme }) => ({
  flexGrow: 1,
  overflow: 'auto',
  minHeight: '100%',
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  [theme.breakpoints.down('md')]: {
    minHeight: '100vh',
  },
  [theme.breakpoints.up('md')]: {
    overflow: 'visible',
    minHeight: 'auto',
  },
  [theme.breakpoints.down('md')]: hideScrollbarSx,
}));

export const Wrapper = styled('div', { label: 'PageWrapper' })(({ theme }) => ({
  minHeight: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  justifyContent: 'flex-start',
  padding: '2vh 0',
  width: '100%',
  height: 'auto',
  [theme.breakpoints.down('md')]: {
    padding: 0,
    flex: 1,
    minHeight: '100vh',
  },
}));

export const OuterContainer = styled('div')(({ theme }) => ({
  background: (theme.palette as any).blue?.light || '#e3f2fd',
  padding: '5px',
  borderRadius: '20px',
  margin: '0',
  boxSizing: 'border-box',
  boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2), 0 6px 20px rgba(0, 0, 0, 0.19)',
  width: '100%',
  height: 'fit-content',
  [theme.breakpoints.down('md')]: {
    margin: 0,
    borderRadius: '0',
    padding: '1px',
    minHeight: '100vh',
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    height: 'auto',
  },
}));

export const InnerContainer = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.common.white,
  borderRadius: '15px',
  padding: '2.6em',
  textAlign: 'left',
  color: (theme.palette.grey as any)?.light || theme.palette.grey[300],
  width: '100%',
  boxSizing: 'border-box',
  [theme.breakpoints.down('xl')]: {
    padding: '0.8em',
    fontSize: '0.9em',
    borderRadius: '0',
  },
  [theme.breakpoints.down('md')]: {
    minHeight: '100vh',
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
  },
}));
